import { render, staticRenderFns } from "./TransitionRouter.vue?vue&type=template&id=750bbbf8&"
import script from "./TransitionRouter.vue?vue&type=script&lang=js&"
export * from "./TransitionRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports